import {shortRootState} from '../../../utils/vuex'
import {findIndex} from '../../../utils/base'
import {isNumber} from 'util'

function formatPath(path) {
  return path ? path.replace(/\/$/, '').replace(/\/index$/, '') : ''
}

export default {
  tabs: shortRootState('config/navTabs'),

  tabIndex({meta, matched}, getters) {
    const {tabs} = getters
    // console.log(fullPath)
    if (tabs) {
      const tabCount = tabs.length
      // fullPath = formatPath(fullPath)
      // let index = meta && isNumber(meta.tabIndex) ? meta.tabIndex : findIndex(tabs, ({path}) => {
      //   path = formatPath(path)
      //   return fullPath === path || `${fullPath}/`.indexOf(`${path}/`) === 0
      // })
      // index = index >= tabCount ? -1 : index
      // return index

      let tabIndex = -2 // -2 不显示底导航  -1: 显示底导航（无高亮） >= 0 显示底导航（高亮对应项）
      // console.log(tabs)
      if (meta && isNumber(meta.tabIndex)) {
        tabIndex = meta.tabIndex
      } else if (matched) {
        // console.log(matched)
        for (let index = matched.length - 1; index >= 0; index--) {
          const route = matched[index]
          const {regex} = route
          const i = findIndex(tabs, ({path}) => regex.test(path))
          // console.log(route.path)
          if (i >= 0) {
            tabIndex = i
            break
          }
        }
      }
      tabIndex = tabIndex >= tabCount ? -1 : tabIndex
      return tabIndex
    }
    return -1
  },

  pageType({fullPath}, getters) {
    // 0 非首页(默认) 1 应用级首页 2 频道级首页
    const {tabs} = getters
    // console.log(fullPath)
    if (tabs) {
      fullPath = formatPath(fullPath)
      const index = findIndex(tabs, ({path}) => {
        return fullPath === formatPath(path)
      })
      return index > -1 ? (index > 0 ? 2 : 1) : 0
    }
    return 0
  },

  canBack(_state, getters) {
    const {pageType} = getters
    return pageType > 0 ? false : true
  }
}
